var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-page cg-page"},[_c('div',{staticClass:"pt20"},[_c('a',{staticClass:"logo",attrs:{"href":"/#/index"}},[_c('img',{attrs:{"src":"static/images/logo1.png"}})])]),_vm._v(" "),_c('div',{staticClass:"content mt50"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-47ab6b7f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/page/blank.vue
// module id = null
// module chunks = 